import { Divider, Form, Select, Input, Button, Image, message  } from "antd"
import { get, post } from "library/endpoints"
import { useEffect, useState } from "react"
import { connect } from "react-redux"

import { withTranslation } from "react-i18next"
import UploadFile from "./components/UploadFile"


const HelpDeskModal = (props) => {

  const [shops, setShops] = useState([])
  const [categories, setCategories] = useState([])
  const [billings, setBillings] = useState([])
  const [photo, setPhoto] = useState(null)
  const [productPhoto, setProductPhoto] = useState(null)
  const [otherPhoto, setOtherPhoto] = useState(null)
  const [selectedCategory, setSelectedCategory] = useState(null)

  useEffect(() => {
    fetchData()    
  }, []) // eslint-disable-line

  const fetchData = async () => {
    try {
      const responseCategories = await get(`/frontend/help-desk/categories`);
      const responseBills = await get(`/frontend/basket/bills`);
      setCategories(responseCategories.data.categories)
      setShops(responseCategories.data.shops);
      setBillings(responseBills.data)
    } catch (error) {
      console.log(error)
    }
  }

  const onFinish = async (values) => {
    try {
      await post(`/frontend/help-desk`, {
        ...values,
        photo,
        product_photo: productPhoto,
        other_photo: otherPhoto
      })
      message.success('Merci, nous reviendrons vers vous très prochainement')
      props.handleOnCancelFormView()
    } catch (error) {
      console.log(error)
      message.error('Une erreur s est produite lors de la soumission de votre formulaire')      
    }
  };
  
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const getSelectedCategoryInfos = () => {
    const category = categories.find((c) => c._id === selectedCategory);
    if (category && category.instructions?.fr) {
      return category.instructions.fr
    }

    return null;
  }

  return (
    <>
      <Form
        name="basic"
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        {
          shops.length > 0 && (
            <Form.Item
              label="Boutique concernée"
              name="_shop"
              initialValue={shops[0]._id}
            >
              <Select
              >
                {
                  shops.map((shop) => (
                    <Select.Option value={shop._id} key={shop._id}>{shop.name}</Select.Option>
                  ))
                }
              </Select>
            </Form.Item>
          )
        }

        <Form.Item
          label="Type de problème rencontré"
          name="_category"
          rules={[
            {
              required: true,
              message: 'Ce champ est obligatoire',

            },
          ]}
        >
          <Select
            onChange={(val) => setSelectedCategory(val)}
          >
            {
              categories.map((category) => (
                <Select.Option value={category._id} key={category._id}>{category.category.fr}</Select.Option>
              ))
            }
          </Select>
        </Form.Item>

        {
          selectedCategory && (
            <div style={{ marginBottom: 20 }}>{getSelectedCategoryInfos()}</div>
          )
        }

        <Form.Item
          label="Facture concernée"
          name="_billing"
        >
          <Select>
            {
              billings.map((billing) => (
                <Select.Option value={billing._id} key={billing._id}>{billing.invoice_label}</Select.Option>
              ))
            }
          </Select>
        </Form.Item>

        <Form.Item
          label="Votre message"
          name="message"
          rules={[
            {
              required: true,
              message: 'Ce champ est obligatoire',

            },
          ]}
        >
          <Input.TextArea autoSize />
        </Form.Item>

        <div style={{ marginBottom: 20 }}>
          <div>
            <UploadFile label={'Photo du défaut constaté'} client={props.auth.user} callback={(url) => setPhoto(url)} auth={props.auth}/>
          </div>
          {
            photo && (
              <Image src={`${process.env.REACT_APP_S3_URL}${photo}`} width={100} style={{ margin: 10 }} />
            )
          }
        </div>

        <div style={{ marginBottom: 20 }}>
          <div>
            <UploadFile label={'Photo générale du produit'} client={props.auth.user} callback={(url) => setProductPhoto(url)} auth={props.auth}/>
          </div>
          {
            productPhoto && (
              <Image src={`${process.env.REACT_APP_S3_URL}${productPhoto}`} width={100} style={{ margin: 10 }} />
            )
          }
        </div>
      
        <div style={{ marginBottom: 20 }}>
          <div>
            <UploadFile label={'Photo complémentaire'} client={props.auth.user} callback={(url) => setOtherPhoto(url)} auth={props.auth}/>
          </div>
          {
            otherPhoto && (
              <Image src={`${process.env.REACT_APP_S3_URL}${otherPhoto}`} width={100} style={{ margin: 10 }} />
            )
          }
        </div>
      
        <Divider />

        <Form.Item
          style={{ marginTop: 20 }}
        >
          <Button type="primary" htmlType="submit">
            Envoyer
          </Button>
          <Button type="link" onClick={props.handleOnCancelFormView}>Annuler</Button>
        </Form.Item>
      </Form>
      </>
    
  )
}

const stateToProps = state => ({
  auth: state.auth
})

export default connect(stateToProps)(withTranslation()(HelpDeskModal))